import {
	IsDateString,
	IsEmail,
	IsObject,
	IsOptional,
	IsString,
	ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';
import { UserDto } from './user.dto';
import { FingerprintDto } from './referral-fingerprint.dto';

export class AuthWithGoogle {
	@IsString()
	@IsOptional()
	idToken?: string;

	@IsString()
	@IsOptional()
	accessToken?: string;
}

export class GoogleUserDto implements Required<Pick<UserDto, 'googleEmail' | 'name'>> {
	googleEmail: string;
	name: string;
}

export class CompleteGoogleSignupDto {
	@IsEmail()
	email: string;

	@IsString()
	name: string;

	@IsDateString()
	birthdate: string;

	@IsOptional()
	@IsString()
	referralCode?: string;

	@IsOptional()
	@IsString()
	inviteToken?: string;

	@IsOptional()
	@IsString()
	college?: string;

	@IsOptional()
	@IsString()
	country?: string;

	@IsOptional()
	@IsObject()
	@ValidateNested()
	@Type(() => FingerprintDto)
	fingerprint?: FingerprintDto;

	@IsOptional()
	@IsString()
	ipAddress?: string;

	@IsOptional()
	@IsString()
	utmSource?: string;
}
